<template>
  <div
    v-once
    class="c-px-1 order-2 bg-primary-200"
  >
    <div class="navbar-secondary__imgbg club-bg-overlay embed-responsive embed-responsive-16by9 c-m-0 hidden c-lg:block">
      <ResponsiveImage
        src="club/intro.jpg"
        img-class="embed-responsive-item image-cover"
        alt="klub intro"
        sizes="(min-width: 1401px) 100vw, (min-width: 1025px) 60vw, (min-width: 769px) 70vw, 60vw"
        :lazy-load="false"
      />
    </div>
    <div class="container">
      <!-- text -->
      <div class="c-pt-2 c-pb-6 c-lg:c-pt-5 c-xl:c-pb-9 row c-justify-center">
        <div class="c-sm:col-10 c-md:col-8 c-lg:col-4 c-xxl:col-5 text-center">
          <h1 class="sr-only">
            {{ t('mixit_subscribers_club') }}
          </h1>
          <ClubHeaderCsSvg
            v-if="locale === 'cs'"
            class="c-w-100 block c-mb-3"
            width="477"
            height="120"
          />
          <ClubHeaderSkSvg
            v-if="locale === 'sk'"
            class="c-w-100 block c-mb-3"
            width="477"
            height="120"
          />
          <p class="h3 c-mb-5">
            {{ t('mix_package_every_month') }}
          </p>
          <a
            href="#packages"
            class="btn btn-success c-py-3 c-px-5 font-medium c-rounded-pill"
            @click="scrollTo"
          >
            {{ t('become_member_of_club') }}
          </a>
        </div>
      </div>
      <!-- Bottom gap -->
      <div class="hidden c-lg:block c-py-8" />
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

import ResponsiveImage from '@/components/general/BaseImage.vue'

import ClubHeaderCsSvg from '../svg/club/ClubHeaderCsSvg.vue'
import ClubHeaderSkSvg from '../svg/club/ClubHeaderSkSvg.vue'

const { t, locale } = useI18n()

const scrollTo = (event) => {
  const href = event.target.getAttribute('href')
  const targetElement = document.querySelector(`#${href.replace('#', '')}`)

  if (targetElement) {
    event.preventDefault()
    const targetOffsetTop = targetElement.getBoundingClientRect().top + document.documentElement.scrollTop
    window.scrollTo({ top: targetOffsetTop, behavior: 'smooth' })
  }
}
</script>

<style lang="scss" scoped>
.club-bg-overlay {
  &:before {
    content: '';
    z-index: 1;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.5);
    -webkit-backdrop-filter: blur(7px);
    backdrop-filter: blur(7px);
  }
}
</style>

<i18n>
  {
    "cs": {
    "become_member_of_club": "Stát se členem Mixit Klubu",
    "mix_package_every_month": "Mixit balík každý měsíc až k vám domů. Výhodněji a bez starostí.",
    "mixit_subscribers_club": "Mixit Klub předplatitelů"
},
    "sk": {
    "become_member_of_club": "Stať sa členom Mixit Klubu",
    "mix_package_every_month": "Mixit balík každý mesiac až k vám domov. Výhodnejšie a bez starostí.",
    "mixit_subscribers_club": "Mixit Klub predplatiteľov"
},
    "pl": {
    "become_member_of_club": "Stań się członkiem Mixit Klubu",
    "mix_package_every_month": "Paczka Mixit co miesiąc. Wygodnie i bez zmartwień.",
    "mixit_subscribers_club": "Mixit Klub"
},
    "hu": {
    "become_member_of_club": "Legyél Mixit Klub tag",
    "mix_package_every_month": "Házhoz szállított Mixit csomag minden hónapban. Kedvezményesen és kényelmesen.",
    "mixit_subscribers_club": "Mixit előfizetők klubja"
},
    "de": {
    "become_member_of_club": "Werde Mitglied im Mixit-Club",
    "mix_package_every_month": "Ein Mixit-Paket jeden Monat direkt zu Dir nach Hause. Vorteilhafter und sorgenfreier.",
    "mixit_subscribers_club": "Mixit Club der Abonnenten "
},
    "at": {
    "become_member_of_club": "Werde Mitglied im Mixit-Club",
    "mix_package_every_month": "Ein Mixit-Paket jeden Monat direkt zu Dir nach Hause. Vorteilhafter und sorgenfreier.",
    "mixit_subscribers_club": "Mixit Club der Abonnenten "
},
    "ro": {
    "become_member_of_club": "Devino membru al clubului Mixit",
    "mix_package_every_month": "Pachetul Mixit livrat la domiciliu. Avantajos și fără griji.",
    "mixit_subscribers_club": "Clubul abonaților Mixit"
},
    "fr": {
    "become_member_of_club": "Devenez membre du Mixit Club",
    "mix_package_every_month": "Le coffret Mixit livré chez vous chaque mois. Plus avantageux et sans souci.",
    "mixit_subscribers_club": "Le Club des abonnés Mixit"
},
    "it": {
    "become_member_of_club": "Diventa membro del Mixit Club",
    "mix_package_every_month": "Il pacchetto Mixit ogni mese direttamente a casa tua. Più conveniente e senza pensieri.",
    "mixit_subscribers_club": "Club degli abbonati Mixit"
}
  }
</i18n>
